import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RolePermissionComponent from "../../permissions/RolePermissionComponent";

const defaultStyles = {
  fontSize: "12px",
  fontWeight: 400,
  mb: "23px",
};

function createPageInfo(label, url) {
  return { label, url };
}

const managements = [
  createPageInfo("Zipcode Assignment", "/manage/zipcode-assignment"),
  createPageInfo("Register", "/manage/register"),
  createPageInfo("User", "/manage/user"),
  createPageInfo("Import Data", "/manage/import-data"),
  createPageInfo("Staff Activities", "/manage/staff-activities"),
  createPageInfo("Health Plans", "/manage/health-plans"),
];

export default function ManagementMenu(props) {
  const { anchorEl, openMenu, closeMenu } = props;

  return (
    <RolePermissionComponent roles={["admin", "manager"]}>
      <Button
        onClick={openMenu}
        sx={{
          mb: defaultStyles.mb,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: defaultStyles.fontSize,
          fontWeight: defaultStyles.fontWeight,
        }}
      >
        <p style={{ margin: 0 }}>Manage</p>
        <KeyboardArrowDownIcon fontSize="small" sx={{ pb: "3px" }} />
      </Button>
      <Menu
        sx={{ mt: "25px" }}
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "left",
          horizontal: "left",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        {managements.map((management, index) => (
          <MenuItem key={index} onClick={closeMenu}>
            <Typography
              component={Link}
              to={management.url}
              sx={{
                textDecoration: "none",
                color: "#222",
                width: "100%",
              }}
            >
              {management.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </RolePermissionComponent>
  );
}
